import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
import { ref, onMounted, onUnmounted, watch } from 'vue';
import home from '../assets/image/home.png';
import home1 from '../assets/image/home1.png';
import news from '../assets/image/news.png';
import news1 from '../assets/image/news1.png';
import my from '../assets/image/my.png';
import my1 from '../assets/image/my1.png';
import { useRoute } from 'vue-router';
export default {
  __name: 'tabbar',
  setup(__props) {
    const route = useRoute();
    const active = ref(0);

    // 监听整个路由对象的变化
    watch(() => route.fullPath,
    // 或者 route.path, route.query, route.params 等
    (newPath, oldPath) => {
      if (window.location.hash === '#/my') {
        active.value = 2;
      } else if (window.location.hash === '#/news') {
        active.value = 1;
      } else if (window.location.hash === '#/index') {
        active.value = 0;
      }
    }, {
      immediate: true
    } // 可选：是否在初始加载时立即执行
    );
    onMounted(() => {});
    onUnmounted(() => {});
    return (_ctx, _cache) => {
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
      const _component_van_tabbar = _resolveComponent("van-tabbar");
      return _openBlock(), _createElementBlock("div", null, [_ctx.$route.path == '/index' || _ctx.$route.path == '/news' || _ctx.$route.path == '/my' || _ctx.$route.path == '/' ? (_openBlock(), _createBlock(_component_van_tabbar, {
        key: 0,
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event),
        "active-color": "#00bac7"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
          to: "/index"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? _unref(home1) : _unref(home)
          }, null, 8, _hoisted_1)]),
          default: _withCtx(() => [_cache[1] || (_cache[1] = _createElementVNode("span", null, "首页", -1))]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          to: "/news"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? _unref(news1) : _unref(news)
          }, null, 8, _hoisted_2)]),
          default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("span", null, "新闻", -1))]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          to: "/my"
        }, {
          icon: _withCtx(props => [_createElementVNode("img", {
            src: props.active ? _unref(my1) : _unref(my)
          }, null, 8, _hoisted_3)]),
          default: _withCtx(() => [_cache[3] || (_cache[3] = _createElementVNode("span", null, "我的", -1))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)]);
    };
  }
};